export function getCSRFParam(): string {
  return document.querySelector<HTMLMetaElement>('meta[name=csrf-param]')
    .content;
}

export function getCSRFToken(): string {
  return document.querySelector<HTMLMetaElement>('meta[name=csrf-token]')
    .content;
}
